import * as React from "react";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

function LinearProgressWithLabel(props) {
  return (
    <Stack
      direction="column"
      spacing={1}
      sx={{ paddingTop: 1, justifyContent: "center", alignItems: "center" }}
    >
      <LinearProgress color="success"
        sx={{ height: 10, width: "100%", borderRadius: 5 }}
        variant="determinate"
        {...props}
      />
      <Typography variant="body2" color="success.main">
        {`${Math.round(props.value)}% Complete`}
      </Typography>
    </Stack>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

export default function ProgressBar(props) {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= props.value ? prevProgress : prevProgress + 1
      );
    }, 20);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Box sx={{ width: "100%" }}>
      <LinearProgressWithLabel value={progress} />
    </Box>
  );
}
